module.exports = __webpack_public_path__ + "img/262.255c2344.png";